import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import Header from '../components/Header'
import ReactHLS from 'react-hls'
import Antena from '../img/antena.png'
import Klapna from '../img/klapna.jpg'

const Stream = () => (
  <Layout>    
    <Header>Pratite uživo</Header>
    <section className="section">
      <div className="container">
        <div className="container-pages" style={{ border: 'none' }}>
          <div className="text-promo-header">
            <h4 className="text-promo-large">
              Festivalska atmosfera na kanalu Moj film i live kamerama
            </h4>
          </div>
          <div className="stream-screen">
            <img className="desktop" src={Antena} />
            <div className="text-promo divback">
              <h4 className="post-header text-center">
                Moj Film
              </h4>
              <div className="stream-container">
                <ReactHLS url={"https://webtvstream.bhtelecom.ba/hls15/moj_film_1200.m3u8"} allowfullscreen mozallowfullscreen={true} webkitallowfullscreen={true} />
              </div>
            </div>
          </div>
          <div className="promo-row">
            <div className="text-promo">
              <p className="text-promo-normal">Na kanalu Moj film će biti emitovan izbor nagrađivanih filmova koji su do sada prikazani na Sarajevo Film Festivalu, a za koje Festival ima autorska prava. Gledaoci će moći pogledati igrane filmove Aferim, Barca Dreams, Blue Jasmine (Jasmine French), Captain Fantastic (Kapetan Fantastični), Gloria, Graduation (Matura), I Am Not Your Negro, Irrational Man (Nerazuman čovjek), Julieta, Magic in the Moonlight (Čarolija na mjesečini), Sing Street (Raspjevana ulica) i The Big Sick (Moja ljubavna priča).</p>
              <p className="text-promo-normal">Također će biti emitovani i dugometražni filmovi Dobar dan za posao (God day for a job) i Mostovi Sarajeva, te dvadeset kratkih filmova koji su nastali u okviru programa Sarajevo grad filma.</p>
              <p className="text-promo-normal">Pored navedenih filmskih sadržaja, tokom trajanja Sarajevo Film Festivala, na kanalu Moj film će se od 16. avgusta uživo emitovati dešavanja sa festivalskog trga i festivalske ulice putem 24h live kamera SFF Trg i SFF Red Carpet, uz specijalni program od 17:00 – 21:00 sati.</p>
            </div>          
          </div>       
          <div className="stream-screen">
            <img className="desktop" src={Antena} />
            <div className="text-promo divback">
              <h4 className="post-header text-center">
                SFF - Trg
              </h4>
              <div className="stream-container">
                <ReactHLS url={"https://webtvstream.bhtelecom.ba/sff_trg_cam.m3u8"}  allowfullscreen mozallowfullscreen={true} webkitallowfullscreen={true} />
              </div>
            </div>
          </div>
          <div className="stream-screen">
            <img className="desktop" src={Antena} />
            <div className="text-promo divback">
              <h4 className="post-header text-center">
                SFF - Red Carpet
              </h4>
              <div className="stream-container">
                <ReactHLS url={"https://webtvstream.bhtelecom.ba/sff_red_carpet_cam.m3u8"}  allowfullscreen mozallowfullscreen={true} webkitallowfullscreen={true} />
              </div>
            </div>
          </div>
          <div className="promo-row">
            <div className="text-promo">
              <p className="text-promo-normal">Kako bi vaš ugođaj bio potpun cijelo vrijeme trajanja Festivala, ove godine smo se potrudili da sve aktuelnosti pratite putem Live kamera, Moja TV usluge i društvenih mreža (Facebook, Instagram).</p>
              <p className="text-promo-normal">Live kamere prate sva događanja sa festivalskog trga i festivalske ulice. Smještene na glavnim pozicijama omogućuju vam direktan prijenos dijelova atmosfere u vaše domove i na mobilne uređaje, kao i putem društvenih mreža.</p>
              <p className="text-promo-normal">Sve to je dostupno potpuno BESPLATNO putem <a href="https://www.bhtelecom.ba/webtv.html" target="_blank">Moja webTV</a>, <a href="http://www.mojatv.ba/" target="_blank">Moja TV usluge</a>, <a href="https://www.facebook.com/bhtelecom/" target="_blank">Facebook stranice</a> i <a href="https://www.instagram.com/bhtelecom/" target="_blank">Instragram profila BH Telecoma</a>, kao i putem Android aplikacije <a href="https://play.google.com/store/apps/details?id=ba.bhtelecom.furajsvojfilm" target="_blank">Furaj svoj film</a>.</p>
              <p className="text-promo-normal">Tokom trajanja Festivala na svim kamerama u pozadini će svirati i vaš omiljeni <a href="http://mojradio.ba/" target="_blank">Moj radio</a>, gdje ćete pored veselih ritmova i dobre muzike dobiti informacije o svim najnovijim dešavanjima, aktuelnostima i akcijskim ponudama BH Telecoma.</p>
              <p className="text-promo-normal">Krol koji će uvijek ići na dnu ekrana obezbijedit će da ne propustite nijednu bitnu informaciju.</p>
              <p className="text-promo-normal">Budite u toku i uživajte u danima trajanja Sarajevo Film Festivala.</p>
            </div>          
          </div>        
        </div>
      </div>
    </section>
  </Layout>
)

export default Stream